@if (body) {
<content-viewer [content]="body" (docRendered)="handleDocRendered($event)"> </content-viewer>
}
